import { Body } from '@ui';
import { Container, Page } from '@ui';
import React from 'react';
import { Loading } from '@ui/Loading';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';

const PageWrapper = styled.div``;
const BodyWrapper = styled.div`
  padding: 24px;
`;

export function PageLoading() {
  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <BodyWrapper>
          <Page>
            <Container vertical={24}>
              <Loading />
            </Container>
          </Page>
        </BodyWrapper>
      </Body>
    </PageWrapper>
  );
}
